export default __webpack_public_path__ + "d0f319cab7149b931e299c276e702791.woff";